export default __webpack_public_path__ + "img/temp.asset.2b0778a8.jpg";